export const DEFAULT_APPEARANCE_COLOR = '#FFFFFF';
